/* unplugin-vue-components disabled */import { render } from "./DialogView.vue?vue&type=template&id=6b3f8237&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"

import "./DialogView.vue?vue&type=style&index=0&id=6b3f8237&lang=scss"
import "./DialogView.vue?vue&type=style&index=1&id=6b3f8237&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f8237"]])

export default __exports__